import {
  DispatchTripRead,
  RunBambiRunReassignedTripRead,
  RunBambiRunTripRead,
  TripRead,
} from 'src/common/external/bambi-api/bambiApi';

export function isActivatedWillCall(
  trip:
    | DispatchTripRead
    | RunBambiRunTripRead
    | RunBambiRunReassignedTripRead
    | TripRead
): boolean {
  if ('is_activated_will_call' in trip) {
    return trip.is_activated_will_call;
  }

  return (
    !!(trip as TripRead).is_will_call &&
    (trip as TripRead).is_will_call_activated
  );
}
